module.exports = __webpack_public_path__ + "img/AccountManage.ebdc35c3.svg";